import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="relative bg-black border-t border-white/10"
      data-testid="site-footer"
    >
      <div className="m-stripe h-[3px] w-full" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-4">
            <div className="m-stripe w-1.5 h-14" />
            <div className="leading-none">
              <span
                className="block text-4xl font-black uppercase tracking-tight text-white"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                Autó-<span className="text-[#0082D2]">Szerelem</span>
              </span>
              <span
                className="block text-[0.85rem] font-bold uppercase tracking-[0.22em] text-zinc-500 mt-2"
                style={{ fontFamily: "Barlow Condensed" }}
              >
                Séra Autószervíz
              </span>
            </div>
          </div>
          <p className="mt-4 text-sm text-zinc-400 max-w-xs">
            Q-Service hálózat tagja Debrecenben. Mert az autó a szerelmünk.
          </p>
          <p className="mt-3 text-xs text-zinc-600">autoszerelem.hu</p>
        </div>

        <div>
          <div
            className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4"
            style={{ fontFamily: "Barlow Condensed" }}
          >
            Szolgáltatások
          </div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>Klíma javítás-töltés</li>
            <li>Automataváltó-olajcsere (MotulEVO)</li>
            <li>Q-Service teljes körű javítás</li>
            <li>Gumiszerelés, centrírozás</li>
            <li>
              <Link to="/bmw" className="hover:text-[#0082D2] transition-colors">
                BMW Szervíz →
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div
            className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4"
            style={{ fontFamily: "Barlow Condensed" }}
          >
            Kapcsolat
          </div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>
              <a
                href="mailto:autoszerelem@gmail.com"
                className="hover:text-[#0082D2]"
              >
                autoszerelem@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+36308637476" className="hover:text-[#0082D2]">
                +36 30 863 7476
              </a>
            </li>
            <li>4031 Debrecen, Vadvirág u. 15/D — 3. kapu</li>
            <li>H–P: 08:00 – 17:00</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © 2026 Autó-Szerelem — Séra Autószervíz, Debrecen ·{" "}
            <span data-testid="build-tag" className="text-zinc-600 mono">
              v2026.01.09
            </span>{" "}
            · Minden jog fenntartva.
          </p>
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs uppercase tracking-[0.2em]">
            <Link
              to="/impresszum"
              className="text-zinc-500 hover:text-zinc-200 transition-colors"
              data-testid="footer-impresszum-link"
            >
              Impresszum
            </Link>
            <Link
              to="/adatkezelesi-tajekoztato"
              className="text-zinc-500 hover:text-zinc-200 transition-colors"
              data-testid="footer-adatkezeles-link"
            >
              Adatkezelés
            </Link>
            <Link
              to="/admin/login"
              className="text-zinc-600 hover:text-zinc-300 transition-colors"
              data-testid="footer-admin-link"
            >
              Admin
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
